import { createObjectPagePathname, getAsServerMediaUrl, getMediaUrl } from "@/services/pathname"
import Link from "next/link"
import moment from "moment"
import { getName } from "@/services/aroeven"
import Image from "next/image"

type CardProps = {
    aroeven: Aroeven,
    pressArticle: PressArticle
}
export default function Card({
    aroeven,
    pressArticle
}: CardProps) {

    console.log(pressArticle)

    return (
        <Link href={(aroeven.federation === false && pressArticle.publishedBy.slug !== aroeven.slug ? pressArticle.publishedBy.url : '') + createObjectPagePathname('PressArticle', pressArticle)} {...aroeven.federation === false && pressArticle.publishedBy.slug !== aroeven.slug && { target: "_blank"}} className="vignette -type-1 h-100">
            <div className="vignette__image">
                <div className="cardImage">
                    <div className="cardImage__content">
                        <Image
                            src={getAsServerMediaUrl(pressArticle.mainImage?.url ?? '#')}
                            width={pressArticle.mainImage.metadata.width}
                            height={pressArticle.mainImage.metadata.height}
                            className="col-12"
                            alt="image"
                            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                            quality={50}
                        />
                        {/*<img className="col-12" src={getMediaUrl(pressArticle.mainImage?.url ?? '#')} alt="image" />*/}
                    </div>
                    <div className="cardImage__leftBadge">
                        <div className="tag">
                            <h3 className="tag-title">{moment(pressArticle.publishedAt).format('DD/MM/YYYY')}</h3>
                            <div className="tag-tail" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="vignette__content pt-10">
                <div className="d-flex flex-column justify-content-between h-100">
                    <div>
                        <h4 className="vignette__title py-10">
                            {pressArticle.title}
                        </h4>
                        <p className="mb-10">{pressArticle.short}</p>
                    </div>
                    <div className="d-flex flex-column justify-content-end">
                        <div className="organisation d-flex items-start">
                            <div className="flex-center size-20 rounded-full bg-primary-3 mr-5 text-white">
                                <i className="fi fi-rr-home" />
                            </div>
                            <div className='lh-1 mb-5'>Publié par {getName(pressArticle.publishedBy)}</div>
                        </div>
                    </div>
                </div>
            </div>
        </Link>

    )
}